/**
 * IAM role that grants standard read access to the Metering feature.
 */
export const METERING_READ_ROLE = "isce.metering.read";

/**
 * IAM role that grants unrestricted browsing of the Metering customers list.
 * Without it, the query-service force-restricts callers to their own customer
 * (see CustomerService#findCustomers in isce-metering-query-service).
 */
export const METERING_ADMIN_ROLE = "isce.metering.admin";

export const isMeteringAdminRole = (roles: string[] | undefined | null): boolean => {
  if (!roles) return false;
  return roles.some((role) => role.trim().toLowerCase() === METERING_ADMIN_ROLE);
};
